import { Heart } from "lucide-react";

export default function MiniHeader({ right }) {
  return (
    <header className="border-b border-[rgba(197,165,90,0.15)] bg-[rgba(11,10,9,0.75)] backdrop-blur-xl sticky top-0 z-40">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between gap-4">
        <a href="/" data-testid="mini-brand-link" className="flex items-center gap-3">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-[rgba(212,175,55,0.4)]">
            <Heart size={16} className="text-[#D4AF37]" strokeWidth={1.4} />
          </span>
          <div className="leading-tight">
            <div className="serif text-[20px] text-[#F5F0E8] tracking-wide">Eternal Legacy</div>
            <div className="overline text-[9px] text-[#C5A55A]/80">Tributes</div>
          </div>
        </a>
        {right}
      </div>
    </header>
  );
}
